module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    staticClass: "order-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "deep-text-color",
    staticStyle: {
      "line-height": "34px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("总计:")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "18px",
      "margin-right": "5px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.totalMoney)))])]), _vm._v(" "), (_vm.showButton) ? _c('div', {
    staticClass: "pay-btn research-background-color",
    on: {
      "click": _vm.response
    }
  }, [_vm._v(_vm._s(_vm.buttonName))]) : _c('div', {
    staticClass: "pay-btn",
    staticStyle: {
      "background-color": "gainsboro"
    }
  }, [_vm._v(_vm._s(_vm.buttonName))])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1db37a3d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/OrderContentFramework.vue
// module id = 1561
// module chunks = 8